import React from 'react'

class LeaveComponentBar extends React.Component {

  barClass() {
    return this.props.next_day_benefit ?  'includes-next-day' : ''
  }

  render() {
    return (
      <div className={`leave-bar ${this.barClass()}`}>  </div>
    )
  }

} 

export default LeaveComponentBar
